import { render, staticRenderFns } from "./McsBaseComponent.vue?vue&type=template&id=5d50bf0a&"
import script from "./McsBaseComponent.vue?vue&type=script&lang=js&"
export * from "./McsBaseComponent.vue?vue&type=script&lang=js&"
import style0 from "./McsBaseComponent.vue?vue&type=style&index=0&id=5d50bf0a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports